import React, {Fragment, useEffect, useRef, useState} from "react";
import database from "../../../../utils/databaseFirebase";
import functions from "../../../../utils/functionsFirebase";
import {FormattedMessage} from "react-intl";
import {IconButton, Spinner} from "../../../shared";
import TagForm from "./tagForm";
import {useSelector} from "react-redux";
import groupIndex from "../../";
import auth from "../../../../utils/authentication";

function TagsMenu({group, hasRightManageTags, tags, setTags}) {

    const [editingTag, setEditingTag] = useState({tag: ""});
    const [openForm, setOpenForm] = useState(false);
    const [validTag, setValidTag] = useState(false);
    const userGroups = useSelector(groupIndex.selectors.userGroups)
    const tagFormRef = useRef();
    const openFormButton = useRef();

    const [loadingSaveTag, setLoadingSaveTag] = useState(false);

    useEffect(() => {
        if (group) {
            resetEditingTag();
            if(!auth.currentUser){
                const groupTagsRef = database.ref('/groupTags/')
                    .orderByChild('groupId')
                    .equalTo(group.id);

                // Set up a listener for changes
                groupTagsRef.on('child_added', snapshot => {
                    if (tags.some(x => x.id === snapshot.key)) {
                        return;
                    }
                    const newTag = snapshot.val();
                    newTag.id = snapshot.key;
                    if (tags.some(x => x.id === newTag.id)) {
                        return;
                    }
                    setTags(prevTags => {
                        const aux = [...prevTags];
                        aux.push(newTag);
                        aux.sort((a, b) => a.tag.localeCompare(b.tag));
                        group.tags = aux;
                        return aux;
                    });
                });
                groupTagsRef.on('child_changed', snapshot => {
                    const newTag = snapshot.val();
                    newTag.id = snapshot.key;
                    setTags(prevTags => {
                        const aux = [...prevTags];
                        const editedIndex = aux.findIndex(x => x.id === newTag.id);
                        aux.splice(editedIndex, 1);
                        aux.push(newTag);
                        aux.sort((a, b) => a.tag.localeCompare(b.tag));
                        group.tags = aux;
                        return aux;
                    })
                });
                groupTagsRef.on('child_removed', snapshot => {
                    setTags(prevTags => {
                        const aux = [...prevTags];
                        const deletedIndex = aux.findIndex(x => x.id === snapshot.key);
                        aux.splice(deletedIndex, 1);
                        group.tags = aux;
                        return aux;
                    })
                });

                return () => {
                    groupTagsRef.off('child_added');
                    groupTagsRef.off('child_changed');
                    groupTagsRef.off('child_removed');
                }
            }
        }

    }, [group?.id]);


    useEffect(() => {
        if (userGroups?.groups) {
            setTags(userGroups.groups.find(x => x.id === group.id)?.tags);
        }
    }, [userGroups])

    const resetEditingTag = () => {
        setEditingTag({tag: ""});
    }


    const toggleOpenFormTag = () => {
        setOpenForm(!openForm);
        if (!openForm) {
            resetEditingTag();
        }
    }

    const saveTag = async () => {
        setLoadingSaveTag(true);
        await tagFormRef.current.saveTag();
        toggleOpenFormTag();
        setLoadingSaveTag(false);
    }

    const deleteTag = async (tag) => {
        const deleteTagFunct = functions.httpsCallable('deleteTag');
        await deleteTagFunct({tag});
    }


    return (
        <div>
            <div>
                {hasRightManageTags &&
                    <Fragment>
                        {!openForm && <div className="d-grid">
                            <button className="btn btn-secondary" type="button" data-bs-toggle="collapse"
                                    onClick={() => toggleOpenFormTag()} ref={openFormButton}
                                    data-bs-target="#collapseTagForm" aria-expanded="false"
                                    aria-controls="collapseTagForm">
                                <FormattedMessage id="tags.create-tag"/>
                            </button>
                        </div>}
                        {openForm && <div className="col-12">
                            <button className="btn btn-danger col-6" type="button" data-bs-toggle="collapse"
                                    onClick={() => toggleOpenFormTag()} disabled={loadingSaveTag}
                                    data-bs-target="#collapseTagForm" aria-expanded="false"
                                    aria-controls="collapseTagForm">
                                <FormattedMessage id="modal.cancel"/>
                            </button>
                            <button className="btn btn-success col-6" type="button" data-bs-toggle="collapse"
                                    onClick={() => saveTag()} disabled={!validTag || loadingSaveTag}
                                    data-bs-target="#collapseTagForm" aria-expanded="false"
                                    aria-controls="collapseTagForm">
                                <FormattedMessage id="app.save-changes"/>
                            </button>
                        </div>}
                        <div className="collapse" id="collapseTagForm">
                            <div className="card card-body">
                                <TagForm tag={editingTag} setValidTag={value => setValidTag(value)} groupId={group.id}
                                         ref={tagFormRef}/>
                            </div>
                        </div>
                        <div className="d-flex flex-row justify-content-center mt-3">
                            {loadingSaveTag && <Spinner/>}
                        </div>
                    </Fragment>}

                <div>
                    <ul className="list-group list-group-flush">
                        {tags && tags.map((tag) => (
                            <li className="list-group-item d-flex flex-row justify-content-between" key={tag.id}>
                            <span className="d-flex flex-row">
                                <div style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "12px",
                                    backgroundColor: tag.color
                                }}
                                     className=" me-3">
                                </div>
                                {tag.tag}
                                <span className="badge text-bg-info ms-4"></span>
                            </span>
                                {hasRightManageTags &&
                                    <div className="d-flex flex-row justify-content-between">
                                        <IconButton icon="fa-solid fa-pen-to-square"
                                                    onClick={() => {
                                                        if (openFormButton?.current) {
                                                            openFormButton.current.click();
                                                            setEditingTag(tag);
                                                        }
                                                    }}/>
                                        <IconButton icon="fa-solid fa-trash"
                                                    className="text-danger ms-2"
                                                    onClick={() => deleteTag(tag)}/>
                                    </div>}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );

}

export default TagsMenu;
